import {describeError, isNetworkError} from '../../../core/error.core.js';
import {tpl} from '../../../i18n/i18n.js';

/**
 * The translated message for a failed request, in the current locale. The raw failure
 * (status and backend text, or the network failure) is logged to the console, since the
 * message shown to the user may leave it out; so is a `TypeError` raised by a bug, which
 * the user only sees as the generic message.
 * @param {unknown} error
 * @param {(error: unknown) => import('../../../core/error.core.js').ErrorDescription} [describe]
 * @returns {string}
 */
export function errorText(error, describe = describeError) {
    if (typeof error?.status === 'number' || isNetworkError(error)) {
        console.warn('Request failed', error.status ?? 'network', error.message);
    } else if (error instanceof TypeError) {
        console.error('Unexpected error', error);
    }
    const description = describe(error);
    return 'text' in description ? description.text : tpl(description.key, description.vars ?? {});
}
